import { useState, useEffect } from "react";
import { useAuth } from "@clerk/clerk-react";
import { axiosAuthed } from "./createAuthedAxios";

export function useUserRole(): string | null {
  const { isSignedIn } = useAuth();
  const [role, setRole] = useState<string | null>(null);

  useEffect(() => {
    if (!isSignedIn) {
      setRole(null);
      return;
    }
    axiosAuthed.get("/auth/me")
      .then((r) => setRole(r.data.role ?? "user"))
      .catch(() => setRole("user"));
  }, [isSignedIn]);

  return role;
}
